import { Form, Input, Select } from "antd";
import { ImageUpload } from ".";
import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { IS_PROD } from "../utils";
import { showAlertAction } from "../store/alert";
import { addNewGuarantor, getStaffsWithParams } from "../store/clients";

const Option = Select.Option;

const RegisterGuarantor = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [handlers, setHandlers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState();
  const { user } = useSelector((state) => state.users);

  useEffect(() => {
    setLoading(true);
    const orgType = user?.position === "UM" ? "branch_id" : undefined;
    const orgFieldId = user?.position === "UM" ? user?.branch?.id : undefined;

    let queryString = "";
    queryString = queryString.concat(`${orgType}=${orgFieldId}`);

    if (user?.position === "BDO") {
      setHandlers([user]);
    } else {
      dispatch(getStaffsWithParams(queryString, "")).then((result) => {
        setHandlers(result);
      });
    }

    setLoading(false);
  }, []);

  const handleSubmit = async (values) => {
    if (!imageUrl && IS_PROD) {
      dispatch(
        showAlertAction({
          message: "Please upload an image before submitting this form.",
          level: "danger",
          isVisible: true,
        })
      );
      return;
    }

    setLoading(true);
    dispatch(addNewGuarantor({ ...values, image: imageUrl }));
    form.resetFields();
    setLoading(false);
  };

  return (
    <>
      <Container fluid>
        <h3 className="page-title mb-4">Register Guarantor</h3>
        <Form form={form} onFinish={handleSubmit}>
          <Row>
            <Col className="" md="6">
              <Form.Item
                name="Title"
                label="title"
                rules={[
                  {
                    required: true,
                    message: "Please provide title",
                  },
                ]}
              >
                <Input
                  placeholder="Title"
                  type="text"
                  className="form-control"
                />
              </Form.Item>
            </Col>
            <Col className="" md="6">
              <Form.Item
                name="surname"
                label="Surname"
                rules={[
                  {
                    required: true,
                    message: "Please provide surname",
                  },
                ]}
              >
                <Input
                  placeholder="Surname"
                  type="text"
                  className="form-control"
                />
              </Form.Item>
            </Col>
            <Col className="" md="6">
              <Form.Item
                name="firstname"
                label="Firstname"
                rules={[
                  {
                    required: true,
                    message: "Please provide a first name",
                  },
                ]}
              >
                <Input
                  placeholder="First Name"
                  type="text"
                  className="form-control"
                />
              </Form.Item>
            </Col>

            <Col className="" md="6">
              <Form.Item
                name="house_address"
                label="House Address"
                rules={[
                  {
                    required: true,
                    message: "Please provide house address",
                  },
                ]}
              >
                <Input
                  placeholder="House Adress"
                  type="text"
                  className="form-control"
                />
              </Form.Item>
            </Col>
            <Col className="" md="6">
              <Form.Item
                name="office_address"
                label="Office/Business Address"
                rules={[
                  {
                    required: true,
                    message: "Please provide office address",
                  },
                ]}
              >
                <Input
                  placeholder="Office/Business Address"
                  type="text"
                  className="form-control"
                />
              </Form.Item>
            </Col>

            <Col className="" md="6">
              <Form.Item
                name="phone_number1"
                label="Phone Number 1"
                rules={[
                  {
                    required: true,
                    message: "Please provide phone number 1",
                  },
                ]}
              >
                <Input
                  placeholder="Phone Number 1"
                  type="number"
                  className="form-control"
                />
              </Form.Item>
            </Col>
            <Col className="" md="6">
              <Form.Item label="Phone Number 2" name="phone_number2">
                <Input
                  placeholder="Phone Number 2"
                  type="number"
                  className="form-control"
                />
              </Form.Item>
            </Col>

            <Col className="" md="6">
              <Form.Item
                name="marital_status"
                label="Marital Status"
                rules={[
                  {
                    required: true,
                    message: "Please provide marital status",
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Select marital Status"
                  optionFilterProp="children"
                  className="custom-input"
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  allowClear
                >
                  <Select.Option value="single" key="single">
                    Single
                  </Select.Option>
                  <Select.Option value="married" key="married">
                    Married
                  </Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col className="" md="6">
              <Form.Item
                name="number_of_children"
                label="Number of children"
                rules={[
                  {
                    required: true,
                    message: "Please provide number of children",
                  },
                ]}
              >
                <Input
                  placeholder="Number of children"
                  type="number"
                  className="form-control"
                />
              </Form.Item>
            </Col>

            <Col className="" md="6">
              <Form.Item
                name="nin"
                label="NIN"
                className="mb-3"
                rules={[
                  {
                    required: true,
                    message: "Please provide a valid NIN",
                  },
                  {
                    min: 11,
                    max: 11,
                    message: "Please provide a valid NIN",
                  },
                ]}
              >
                <Input
                  placeholder="Your NIN number"
                  type="number"
                  className="form-control"
                />
              </Form.Item>
            </Col>
            <Col className="" md="6">
              <Form.Item
                name="handler_id"
                rules={[
                  {
                    required: true,
                    message: "Please select a handler",
                  },
                ]}
                label="Select Handler"
              >
                <Select
                  showSearch
                  placeholder="Select client handler"
                  optionFilterProp="children"
                  className="custom-input"
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  allowClear
                >
                  {handlers?.map((inst) => (
                    <Select.Option value={inst.id} key={inst.id}>
                      {inst.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col>
              <ImageUpload
                uploadDir="guarantors"
                onImageUpload={setImageUrl}
                onDeleteImage={() => setImageUrl(undefined)}
              />
            </Col>
          </Row>

          <Row className="mt-3">
            <Col>
              <Button
                variant="primary"
                className="px-5"
                type="submit"
                disabled={loading}
              >
                {loading ? "Loading..." : "Submit"}
              </Button>
            </Col>
          </Row>
        </Form>
      </Container>
    </>
  );
};

export { RegisterGuarantor };
